import type { DraftContent } from '../types/contentTypes';
import type { PreviewEntityData } from './extractEntityData';
import extractEntityData from './extractEntityData';

const toSeoImage = (entityData: $TSFixMe) => {
  const { url = '', width, height, alt = '', caption = '', id = '' } = entityData;
  const imageUrl = url ? `https://static.wixstatic.com/media/${url.replace('media/', '')}` : '';
  return {
    imageUrl,
    imageWidth: width,
    imageHeight: height,
    imageAlt: alt,
    imageCaption: caption,
    ...(Boolean(id) && { imageId: id }),
  };
};

const toSeoVideo = (entityData: $TSFixMe) => {
  const { url = '', thumbnail = '', caption = '' } = entityData;
  const videoThumbnailUrl = thumbnail.startsWith('media/')
    ? `https://static.wixstatic.com/${thumbnail}`
    : thumbnail;
  const videoContentUrl = url.startsWith('video/') ? `https://video.wixstatic.com/${url}` : url;
  return { videoThumbnailUrl, videoContentUrl, videoName: caption };
};

const gifToSeoVideo = (entityData: $TSFixMe) => {
  const { mp4: videoContentUrl = '', thumbnail: videoThumbnailUrl = '' } = entityData;
  return { videoThumbnailUrl, videoContentUrl, videoName: '' };
};

export const extractMedia = ({ entityMap }: DraftContent) =>
  Object.values(entityMap)
    .filter(entity =>
      [
        'wix-draft-plugin-image',
        'wix-draft-plugin-giphy',
        'wix-draft-plugin-gallery',
        'wix-draft-plugin-video',
      ].includes(entity.type)
    )
    .reduce((media, entity) => [...media, ...extractEntityData(entity)], [] as PreviewEntityData[])
    .map(entityData => {
      const map = { image: toSeoImage, video: toSeoVideo, giphy: gifToSeoVideo };
      return map[entityData.type as $TSFixMeKey<typeof map>](entityData);
    });
